import { Card, CardProps, PageHeader, Space } from 'antd';
import React, {forwardRef } from 'react';
import classNames from 'classnames';
import './index.scss';

const cx = classNames.bind('./index.scss');

export interface CardLayoutProps extends CardProps {}

const CardLayoutComponent = forwardRef<HTMLDivElement, React.PropsWithChildren<CardLayoutProps>>((
  { children, bodyStyle, style, headStyle, title, className },
  ref
): React.ReactElement => {
  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <Card
      className={cx('cardLayout')}
      title={title}
      bordered={false}
      style={style}
      headStyle={{ border: 'none', ...headStyle }}
      bodyStyle={bodyStyle}
      ref={ref}
    >
      {children}
    </Card>
  );
});

CardLayoutComponent.displayName = 'CardLayout';

export default CardLayoutComponent;
